import { GridContainer } from 'libs/ui';
import { Subscription } from 'grids/subscription/subscription';

export const SubscriptionWrapper = (props) => {
  return (
    <GridContainer>
      <Subscription {...props} />
    </GridContainer>
  );
};
